<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="1300_auto"
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      登记入库
    </template>
    <template #content>
      <el-form
          ref="form"
          :model="form">
        <gj-table
          :index="false"
          :loading="loading"
          name="createDeliveryOrder"
          :data="form.items"
          :columns="columns"
          :show-overflow="false"
          :show-header-overflow="false"
          :structure-config="{type: 'ParentChild', children: 'items', parentSpan: [0, 8]}"
          :offset-height="88">
          <template v-slot:code="{row}">
            <template v-if="row.$gjParentData">
              <div style="display: inline-block; width: 150px;">
                {{row.deliveryNoteCode | defaultShow}}
              </div>
              <div v-gutter="20" style="display: inline-block;">
                <span>{{row.deliveryWarehouseName | defaultShow}}</span>
                <gj-text max-width="120px">{{row.supplierName | defaultShow}}</gj-text>
                <gj-tag
                    type="dark"
                    shape="rectangle"
                    :color="row.settlementWay | optionColor(PurchaseOrderEnum.settleOption)">
                  {{ row.settlementWay | optionText(PurchaseOrderEnum.settleOption) }}
                </gj-tag>
                <span>入库量/良品量/次品量：{{row.totalInboundQuantity || 0}} / {{row.totalInboundGoodQuantity || 0}} / {{row.totalInboundBadQuantity || 0}}</span>
              </div>
            </template>
            <template v-else>
              {{row.purchaseOrderCode | defaultShow}}
            </template>
          </template>
          <template v-slot:sku="{row}">
            <div>
              <gj-text>{{row.productName | defaultShow}}</gj-text>
            </div>
            <div>{{row.sku | defaultShow}}</div>
            <div>{{row.productType | optionText(productTypeOption)}} - {{row.categoryName | defaultShow}}</div>
          </template>
          <template v-slot:header:goodNum>
            <span class="required-icon">*</span>良品量
            <gj-link @click="setGoodNum">
              <span v-if="setGoodNumSwitch">一键填入</span>
              <span v-else>一键清零</span>
            </gj-link>
          </template>
          <template v-slot:goodNum="{row}">
            <el-form-item
                :prop="`items.${row.$gjParentIndex}.items.${row.$gjChildIndex}.goodNum`"
                :rules="[
                    { required: true, message: '请输入入库良品量', trigger: ['change'] },
                  $gjReRule(RE.pt0, '请输入正整数')
                ]"
                class="gj-table-item">
              <gj-input
                  v-model="form.items[row.$gjParentIndex].items[row.$gjChildIndex].goodNum"
                  width="130px">
              </gj-input>
            </el-form-item>
          </template>
          <template v-slot:header:badNum>
            <span class="required-icon">*</span>次品量
            <gj-link @click="setBadNum">
              <span v-if="setBadNumSwitch">一键填入</span>
              <span v-else>一键清零</span>
            </gj-link>
          </template>
          <template v-slot:badNum="{row}">
            <el-form-item
                :prop="`items.${row.$gjParentIndex}.items.${row.$gjChildIndex}.badNum`"
                :rules="[
                    { required: true, message: '请输入入库次品量', trigger: ['change'] },
                  $gjReRule(RE.pt0, '请输入正整数')
                ]"
                class="gj-table-item">
              <gj-input
                  v-model="form.items[row.$gjParentIndex].items[row.$gjChildIndex].badNum"
                  width="130px">
              </gj-input>
            </el-form-item>
          </template>
        </gj-table>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {formDeleteItemMixin, formRuleMixin, modalMixIn, responseMixin} from "@/minxins";
  import {PurchaseOrderEnum} from "../../../../purchase/purchase-order/enum";
  import {ProductEnum} from "@/utils/options";
  import {registerInbound} from "@/api/warehouse";

  export default {
    name: "app-inbound-product-modal",
    mixins: [modalMixIn, formRuleMixin, formDeleteItemMixin, responseMixin],
    props: {
      inboundOrders: {
        required: true
      }
    },
    data() {
      return {
        tableData: [],
        loading: false,
        columns: [
          {id: 'code', header: '采购单号', field: 'slot:code', width: '150px'},
          {id: 'picture', header: '图片', field: 'picture:skuImageUrl', width: '60px'},
          {id: 'sku', header: '产品名称/SKU/产品类型-品类', field: 'slot:sku', minWidth: '200px'},
          {id: 'singleQuantity', header: '单箱数量', field: 'singleQuantity', width: '70px', align: 'right'},
          {id: 'deliveryQuantity', header: '交货量', field: 'deliveryQuantity', width: '70px', align: 'right'},
          {id: 'inboundGoodQuantity', header: '入库良品量', field: 'inboundGoodQuantity', width: '80px', align: 'right'},
          {id: 'inboundBadQuantity', header: '入库次品量', field: 'inboundBadQuantity', width: '80px', align: 'right'},
          {id: 'goodNum', header: 'slot:goodNum', field: 'slot:goodNum', width: '170px'},
          {id: 'badNum', header: 'slot:badNum', field: 'slot:badNum', width: '170px'}
        ],
        form: {
          items: []
        },
        PurchaseOrderEnum: PurchaseOrderEnum,
        productTypeOption: ProductEnum.typeOption,
        setGoodNumSwitch: true,
        setBadNumSwitch: true
      }
    },
    created() {
      this.form.items = this.inboundOrders.map(item => ({
        ...item,
        items: item.items.map(childItem => ({
          ...childItem,
          goodNum: null,
          badNum: null
        }))
      }));
    },
    methods: {
      setGoodNum() {
        this.form.items.forEach(item => {
          item.items.forEach(childItem => {
            if (this.setGoodNumSwitch) {
              const goodNum = (childItem.deliveryQuantity
                - childItem.inboundGoodQuantity
                - childItem.inboundBadQuantity
                - (!isNaN(childItem.badNum) ? Number(childItem.badNum) : 0));
              if (goodNum >= 0) {
                this.$set(childItem, 'goodNum', goodNum);
              }
            } else {
              this.$set(childItem, 'goodNum', 0);
            }
          });
        });
        this.setGoodNumSwitch = !this.setGoodNumSwitch;
      },
      setBadNum() {
        this.form.items.forEach(item => {
          item.items.forEach(childItem => {
            if (this.setBadNumSwitch) {
              const badNum = (childItem.deliveryQuantity
                - childItem.inboundGoodQuantity
                - childItem.inboundBadQuantity
                - (!isNaN(childItem.goodNum) ? Number(childItem.goodNum) : 0));
              if (badNum >= 0) {
                this.$set(childItem, 'badNum', badNum);
              }
            } else {
              this.$set(childItem, 'badNum', 0);
            }
          });
        });
        this.setBadNumSwitch = !this.setBadNumSwitch;
      },
      confirm() {
        if (this.$gjFormValidate()) {
          const inFlag = this.form.items.some(item => item.items.some(childItem => {
            return childItem.goodNum > 0 || childItem.badNum > 0
          }));
          if (!inFlag) {
            this.$gjMessage.error('至少填写一条入库数量信息');
            return;
          }
          const params = this.form.items.map(item => ({
            deliveryNoteCode: item.deliveryNoteCode,
            deliveryNoteId: item.deliveryNoteId,
            deliveryWarehouseId: item.deliveryWarehouseId,
            items: item.items.map(childItem => ({
              sku: childItem.sku,
              deliveryNoteItemId: childItem.deliveryNoteItemId,
              inboundBadQuantity: childItem.badNum,
              inboundGoodQuantity: childItem.goodNum,
            }))
          }));
          this.confirmLoading = true;
          registerInbound(params)
            .then(res => {
              this.$gjResponseHandle(res, () => {
                this.$gjMessage.success('操作成功');
                this.$emit('created');
                this.$gjDestroy();
              });
            })
            .complete(() => this.confirmLoading = false);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
</style>
